export default "__VITE_ASSET__y1wJn3oh__"